import Grid from "@material-ui/core/Grid";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
//import TextField from '../../TextField/TextField'
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import { Checkbox } from "@material-ui/core";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { profileDriverAddNewPhone } from "../../../store/profile/action";
import { getProfileData } from "../../../store/profile/selector";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
  additionalDetails: {
    textAlign: "left",
    fontSize: "20px",
    fontWeight: "bold",
  },
  txtLeft: {
    textAlign: "left",
    width: "100%",
  },
  textInput: {
    width: "100%",
  },
  selectBox: {
    width: "100%",
    height: 50,
  },
  btnSave: {
    paddingLeft: 50,
    paddingRight: 50,
    backgroundColor: "#20419a",
    color: "white",
  },
  btnRow: {
    textAlign: "right",
    marginTop: 20,
  },
  vin: {
    textAlign: "left",
  },
}));

const AddPhoneNumberModalForm = (props) => {
  const { handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const profileStore = useSelector(getProfileData);
  const { accountId, id } = profileStore;
  const [state, setState] = useState({});

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const formik = useFormik({
    initialValues: {
      accountId: profileStore?.endUserAccountEntity?.id,
      defaultFlag: true,
      number: "",
      extension: "",
    },
    onSubmit: (values) => {
      dispatch(
        profileDriverAddNewPhone({
          values: {
            ...values,
            ["number"]: values.number.replace(/[()  -]/g, ""),
          },
          profileStore,
        })
      );
      // alert(JSON.stringify(values, null, 2));
    },
  });

  /**  this function will add mask on phone number input field */
  const normalizeInput = (value, previousValue) => {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7)
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    }
  };

  const handleCheckbox = (e) => {
    formik.setFieldValue("defaultFlag", e.target.checked);
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit} className="dphone">
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}  style={{marginBottom:20}}>
            <InputLabel htmlFor="outlined-make" className={classes.vin}>
              Phone Number *
            </InputLabel>
            <TextField
              level="Phone Number *"
              type={"text"}
              id={"number"}
              name="number"
              onChange={(e) => {
                formik.setFieldValue(`number`, normalizeInput(e.target.value));
              }}
              value={formik && formik.values.number}
              className={classes.textInput}
              placeholder={"( ) -"}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <InputLabel htmlFor="outlined-make" className={classes.vin}>
              Extension
            </InputLabel>
            <TextField
              level="( )-"
              type={"text"}
              name="extension"
              id="extension"
              onChange={formik.handleChange}
              value={formik && formik.values.extension}
              className={classes.textInput}
            />
          </Grid>
            <Grid item xs={13} >
            <div className='d-flex justify-content-between align-items-center mt-3'>
              <Checkbox name="defaultFlag" checked={formik.values.defaultFlag} color="primary" onChange={handleCheckbox} />
              <InputLabel htmlFor="outlined-make" className={classes.vin}>Set The Default  Number{" "}</InputLabel>
            </div>
            </Grid>
         
            <Grid item xs={12} >
              <div className='d-flex justify-content-between align-items-center mt-3'>
           <Button onClick={handleClose} className="mr-2">Cancel</Button>
            <Button
              variant="contained"
              type="submit"
              color="primary"
              className={classes.btnSave}
            >
              Save
            </Button>
        </div>
            </Grid>
       
        </Grid>
     
        
      </form>
    </>
  );
};

export default AddPhoneNumberModalForm;
